<template>
  <section>
    <b-container>
      <b-row>
        <b-col class="position-relative">
          <div class="content-wrapper">
            <h1 class="heading">Câncer de colo do útero</h1>
            <p class="text">
              Indicadores e materiais informativos para gestores, profissionais e população.
            </p>
            <div class="colo-utero__heading-logos">
              <img
                class="colo-utero__heading-logo--secretaria-saude"
                src="@/assets/img/sponsors/logo-secretaria-saude-rs.svg"
                alt="Secretaria da saúde RS" />
              <img
                class="colo-utero__heading-logo--telessauders"
                src="@/assets/img/sponsors/logo-telessauders.svg"
                alt="Telessaúde RS" />
              <img
                class="colo-utero__heading-logo--cosems"
                src="@/assets/img/sponsors/logo-cosems-rs.png"
                alt="cosems RS" />
            </div>
          </div>
          <div class="backrgound-img"></div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: 'heading-section-cancer-colo-utero',
};
</script>

<style lang="scss" scoped>
.heading {
  color: $primary;
  font-size: 1.625rem;
  font-weight: 600;
  margin-bottom: 1.25rem;
}

.text {
  font-size: .875rem;
  line-height: 1.7;
}

.colo-utero__heading-logos {
  height: 65px;
  text-align: center;
  margin-top: 2rem;
  .colo-utero__heading-logo--secretaria-saude { max-width: 74px; }
  .colo-utero__heading-logo--telessauders {
    max-width: 64px;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .colo-utero__heading-logo--cosems { max-width: 120px; }
}

.backrgound-img {
  width: 100%;
  display: block;
  padding-top: 65.1%;
  background-image: url('@img/cancer-colo-utero/fita-cancer-colo-utero.png');
  background-repeat: no-repeat;
  background-size: 125%;
  background-position: center;
}

@include media-breakpoint-up(sm) {
  .colo-utero__heading-logos {
    height: 104px;
    .colo-utero__heading-logo--secretaria-saude { max-width: 120px; }
    .colo-utero__heading-logo--telessauders {
      max-width: 100px;
      margin-left: 2rem;
      margin-right: 2rem;
    }
    .colo-utero__heading-logo--cosems { max-width: 160px; }
  }
}

@include media-breakpoint-up(md) {
  .colo-utero__heading-logos { text-align: left; }
}

@include media-breakpoint-up(lg) {
  .content-wrapper {
    max-width: 532px;
    padding: 5rem 0;
    z-index: 1;
    position: relative;
  }
  .heading { font-size: 2.75rem; }
  .text {
    font-size: 1rem;
    margin-bottom: .5rem;
  }
  .colo-utero__heading-logos { margin-top: 0; }
  .backrgound-img {
    position: absolute;
    top: 0;
    right: 0;
    width: 580px;
    height: 420px;
    padding: 0;
  }
}

@include media-breakpoint-up(xl) {
  .text { margin-bottom: 6rem; }
  .backrgound-img {
    width: 858px;
    height: 470px;
    background-size: 100%;
    background-position: 115px -60px;
  }
}
</style>
